module.exports = __webpack_public_path__ + "img/folder-white.9da11589.svg";